import type { Translations } from "../types";

const ro: Translations = {
  "meta.title": "Clickuri pe Harta Țărilor",
  "meta.description":
    "Hartă interactivă a lumii: clickuri gratuite pentru fiecare țară, plus susținere plătită prin Stripe, PayPal și Buy Me a Coffee.",

  "app.title": "Clickuri pe Harta Țărilor",

  "map.intro":
    "Dă click pe o țară de pe hartă pentru a-i oferi un vot gratuit sau trimite-i sprijin financiar - ambele contează pentru clasamentul combinat de mai jos. Harta reflectă doar sprijinul din această aplicație, nu bogăția națională sau PIB-ul real.",
  "map.verifying": "Se verifică …",
  "map.confirmNotRobot": "Înainte de a putea adăuga clickuri gratuite, confirmă rapid că nu ești un robot:",
  "map.tryAgain": "Încearcă din nou",
  "map.registeringClick": "Se înregistrează click-ul …",
  "map.selectedCountry": "Țară selectată: {name}.",
  "map.selectFirstFeedback": "Țară selectată. Pentru a adăuga un click gratuit, confirmă mai jos că nu ești un robot.",
  "map.verificationExpired": "Verificarea a expirat - confirmă din nou că nu ești un robot.",
  "map.slowDown": "Mai încet - așteaptă puțin înainte de următorul click.",
  "map.clickFailed": "Nu am putut înregistra click-ul. Te rugăm să încerci din nou.",
  "map.clickErrorGeneric": "Eroare la înregistrarea click-ului.",
  "map.leaderboardHeading": "Clasamentul Țărilor",
  "map.emptySelection": "Selectează o țară pe hartă pentru a-i da click sau a o susține.",
  "map.loadingData": "Se încarcă datele …",

  "worldmap.loadError": "Nu am putut încărca harta.",
  "worldmap.resetZoom": "Resetează zoom-ul",
  "worldmap.resetButton": "⤾ Resetează",
  "worldmap.loadingMap": "Se încarcă harta …",
  "worldmap.unknownCountry": "Necunoscută",
  "worldmap.ariaClicks": "{name}: {clicks} clickuri",
  "worldmap.tooltipClicks": "{clicks} clickuri",

  "legend.fewer": "Mai puține clickuri",
  "legend.more": "Mai multe clickuri",

  "list.empty": "Niciun click încă. Fii primul!",
  "list.ariaLabel": "Clasamentul țărilor după clickuri",

  "human.siteKeyMissing": "VITE_TURNSTILE_SITE_KEY nu este setat - vezi README pentru configurare.",
  "human.verificationFailedGeneric": "Verificarea a eșuat.",
  "human.networkError":
    "Nu am putut contacta verificarea (eroare de rețea) - verifică VITE_SUPABASE_URL, dacă verify-human este publicat, și ALLOWED_ORIGIN; vezi README/NAVODILA.",
  "human.verificationFailedRetry": "Verificarea a eșuat, încearcă din nou.",

  "provider.stripe": "💳 Card (Stripe)",
  "provider.paypal": "🅿️ PayPal",
  "provider.buymeacoffee": "☕ Buy Me a Coffee",

  "panel.selectedCountryLabel": "Țara selectată",
  "panel.currentlyRanked": "Momentan pe locul #{rank}",
  "panel.shareCopied": "Copiat ✓",
  "panel.shareShared": "Distribuit ✓",
  "panel.shareButton": "🔗 Distribuie",

  "panel.tableClicks": "Clickuri",
  "panel.tableFree": "Gratuite",
  "panel.tablePaid": "Plătite",
  "panel.rowAllTime": "Tot timpul",
  "panel.rowThisYear": "Anul acesta",
  "panel.rowThisWeek": "Săptămâna aceasta",
  "panel.rowToday": "Astăzi",

  "panel.totalCombined": "Total combinat:",
  "panel.totalSupport": "Total sprijin:",

  "panel.paymentMethod": "Metodă de plată",
  "panel.noPaymentMethod": "Momentan nu este disponibilă nicio metodă de plată.",
  "panel.supportAmount": "Suma de sprijin (EUR)",
  "panel.amountRange": "Suma trebuie să fie între {min} și {max}.",
  "panel.quickAmount": "{eur} €",
  "panel.estimatedClicks": "Clickuri plătite estimate:",
  "panel.ratioInfo":
    "Raport: {a} = {b} clickuri (de ex. {c} = {d} clickuri). Aceasta este doar o estimare înainte de plată - numărul final de clickuri este întotdeauna calculat și confirmat de server pe baza plății efectiv confirmate.",
  "panel.preparing": "Se pregătește …",
  "panel.continueWith": "Continuă cu {provider}",
  "panel.choosePaymentMethod": "Alege o metodă de plată",
  "panel.bmcUsernameMissing": "VITE_BMC_USERNAME nu este setat - vezi README pentru configurare.",
  "panel.paypalClientIdMissing": "VITE_PAYPAL_CLIENT_ID nu este setat - vezi README pentru configurare.",

  "panel.paypalAmountInfo": "Sumă: {amount} (estimat {clicks} clickuri). Finalizează plata cu butonul PayPal de mai jos.",
  "panel.back": "← Înapoi",

  "panel.bmcWarningTitle": "⚠️ Înainte să continui pe BuyMeCoffee:",
  "panel.bmcWarningBody":
    "Lipește codul de mai jos în câmpul de mesaj/notă de la finalizarea comenzii — este singurul mod prin care aflăm pentru ce țară oferi sprijin. Fără cod, nu putem atribui plata niciunei țări.",
  "panel.copy": "Copiază",
  "panel.copied": "Copiat ✓",
  "panel.suggestedAmount": "Sumă sugerată:",
  "panel.bmcAmountNote":
    "(estimat {clicks} clickuri). Din păcate, BuyMeCoffee nu permite transmiterea sumei prin link — introdu/selecteaz-o singur pe site-ul lor. Numărul real de clickuri este întotdeauna calculat pe baza sumei trimise efectiv pe BuyMeCoffee, nu pe baza acestei estimări.",
  "panel.openBmc": "Deschide BuyMeCoffee și continuă →",
  "panel.waitingProvider": "Se așteaptă confirmarea plății de la furnizorul de plăți …",
  "panel.waitingConfirmation": "Se așteaptă confirmarea plății …",
  "panel.timedOut":
    "Verificarea a expirat. Dacă ai finalizat plata, harta se va actualiza de îndată ce serverul primește confirmarea - uneori poate dura puțin mai mult.",
  "panel.checkAgain": "Verifică din nou",

  "panel.cancelled": "Plata a fost anulată sau nu a reușit. Harta nu s-a schimbat.",
  "panel.tryAgain": "Încearcă din nou",

  "panel.confirmed": "✅ Sprijin confirmat!",
  "panel.confirmedBody": "{country} a primit {clicks} clickuri plătite pentru {amount}.",

  "panel.errorPreparingSupport": "Eroare la pregătirea sprijinului tău.",
  "panel.errorPreparingPayment": "Eroare la pregătirea plății.",
  "panel.errorConfirmingPayment": "Eroare la confirmarea plății.",
  "panel.errorPayingPaypal": "Eroare la plata cu PayPal.",

  "share.unranked": "{flag}{country} are nevoie de sprijinul tău pe harta lumii!\nAjut-o să urce în clasament 👇",
  "share.rank1": "{flag}{country} este momentan pe locul #1!\nAjută-ne să rămânem în frunte 👇",
  "share.rankN": "{flag}{country} este momentan pe locul #{rank}!\nAjută-ne să ajungem pe #1 👇",

  "language.switcherLabel": "Limbă",
};

export default ro;
